import MarketingUpgradePage from "./views/MarketingUpgradePage";
import MarketingUpgradeDialog from "./views/MarketingUpgradeDialog";

const routes = [
  {
    path: "/marketing-upgrade-page/",
    name: "marketing-upgrade-page",
    component: MarketingUpgradePage,
    props: {
      mode: 'page'
    }
  },
  {
    path: "/marketing-upgrade-dialog/",
    name: "marketing-upgrade-dialog",
    component: MarketingUpgradeDialog,
    props: route => ({
      asset: route.query.asset,
    }),
  }
];

export default routes;
